export function markAsViewed() {
    localStorage.setItem('bri|welcome-message-viewed', 'true');
}

export function hasBeenViewed() {
    return localStorage.getItem('bri|welcome-message-viewed') === 'true';
}
